function _instanceof(left, right) {
  return null != right && "undefined" != typeof Symbol && right[Symbol.hasInstance] ? right[Symbol.hasInstance](left) : left instanceof right;
}

function _typeof(obj) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(target, props) {
  for (var descriptor, i = 0; i < props.length; i++) {
    descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
}

function _possibleConstructorReturn(self, call) {
  return call && ("object" === _typeof(call) || "function" == typeof call) ? call : _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self;
}

function _inherits(subClass, superClass) {
  if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: !0,
      configurable: !0
    }
  }), superClass && _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  return _setPrototypeOf = Object.setPrototypeOf || function (o, p) {
    return o.__proto__ = p, o;
  }, _setPrototypeOf(o, p);
}

import assert from "../assert";
import TransitionInterpolator from "./transition-interpolator";
import { flyToViewport } from "viewport-mercator-project";
import { isValid, lerp, getEndValueByShortestPath } from "./transition-utils";

var VIEWPORT_TRANSITION_PROPS = ["longitude", "latitude", "zoom", "bearing", "pitch"],
    REQUIRED_PROPS = ["latitude", "longitude", "zoom", "width", "height"],
    LINEARLY_INTERPOLATED_PROPS = ["bearing", "pitch"],
    ViewportFlyToInterpolator = function (_TransitionInterpolat) {
  function ViewportFlyToInterpolator() {
    var _this;

    return _classCallCheck(this, ViewportFlyToInterpolator), _this = _possibleConstructorReturn(this, (ViewportFlyToInterpolator.__proto__ || Object.getPrototypeOf(ViewportFlyToInterpolator)).call(this)), _this.propNames = VIEWPORT_TRANSITION_PROPS, _this;
  }

  return _inherits(ViewportFlyToInterpolator, _TransitionInterpolat), _createClass(ViewportFlyToInterpolator, [{
    key: "initializeProps",
    value: function initializeProps(startProps, endProps) {
      for (var startViewportProps = {}, endViewportProps = {}, _i = 0; _i < REQUIRED_PROPS.length; _i++) {
        var key = REQUIRED_PROPS[_i],
            startValue = startProps[key],
            endValue = endProps[key];
        assert(isValid(startValue) && isValid(endValue), "".concat(key, " must be supplied for transition")), startViewportProps[key] = startValue, endViewportProps[key] = getEndValueByShortestPath(key, startValue, endValue);
      }

      for (var _i2 = 0; _i2 < LINEARLY_INTERPOLATED_PROPS.length; _i2++) {
        var _key = LINEARLY_INTERPOLATED_PROPS[_i2],
            _startValue = startProps[_key] || 0,
            _endValue = endProps[_key] || 0;

        startViewportProps[_key] = _startValue, endViewportProps[_key] = getEndValueByShortestPath(_key, _startValue, _endValue);
      }

      return {
        start: startViewportProps,
        end: endViewportProps
      };
    }
  }, {
    key: "interpolateProps",
    value: function interpolateProps(startProps, endProps, t) {
      for (var key, viewport = flyToViewport(startProps, endProps, t), _i3 = 0; _i3 < LINEARLY_INTERPOLATED_PROPS.length; _i3++) {
        key = LINEARLY_INTERPOLATED_PROPS[_i3], viewport[key] = lerp(startProps[key], endProps[key], t);
      }

      return viewport;
    }
  }]), ViewportFlyToInterpolator;
}(TransitionInterpolator);

export { ViewportFlyToInterpolator as default };